module.exports = __webpack_public_path__ + "static/media/cancelAccount.00aa5f8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/cancelAccount.png
// module id = 1880
// module chunks = 0